import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./Percentage.css";

const Percentage = ({
  data,
  icon,
  unit,
  numberOfIcon,
  text,
  backgroundColor,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        paddingTop: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexFlow: "wrap",
        }}
      >
        {Array.from({ length: numberOfIcon }).map((_, idx) => {
          const v = Math.floor(data / numberOfIcon);

          return (
            <FontAwesomeIcon
              icon={icon}
              style={{
                width: 40,
                height: 70,
                color: idx + 1 <= v ? backgroundColor[0] : backgroundColor[1],
              }}
            />
          );
        })}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexBasis: "50%",
          paddingTop: 20,
          gap: 30,
        }}
      >
        <div style={{ fontSize: 40, fontWeight: "bold" }}>
          {data}
          {unit}
        </div>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>{text}</div>
      </div>
    </div>
  );
};
export default Percentage;
